module.exports = __webpack_public_path__ + "img/8d7ca78f1824624fb5ed90bf5f7df6d0.9fc844b0.png";